import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import ExportJobsTable from "./components/ExportJobsTable/ExportJobsTable";

const EXPORT_JOBS_PAGE_TITLE = "Quản lý xuất file";

const ExportJobsWebLayout: FC = () => {
  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: EXPORT_JOBS_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <ExportJobsTable />
      </PageContent>
    </Stack>
  );
};

export default ExportJobsWebLayout;
